import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const StickyDemoButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.75);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
    >
      <Link
        to="/contact"
        className="flex items-center gap-2.5 px-6 py-3.5 rounded-full text-white font-bold text-sm whitespace-nowrap cursor-pointer"
        style={{
          background: 'linear-gradient(135deg, #0ea5e9, #38bdf8)',
          boxShadow: '0 4px 30px rgba(14, 165, 233, 0.5), 0 0 0 1px rgba(14,165,233,0.3)',
        }}
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-calendar-check-line text-white text-base"></i>
        </div>
        Book a Free Demo
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-right-line text-white text-base"></i>
        </div>
      </Link>
    </div>
  );
};

export default StickyDemoButton;
